import React from 'react';
import formatBRL from '../../../shared/utils/formatBRL';
import './FinancialSummaryCard.css';

// Impostos não é exibido: o sistema não rastreia esse dado hoje (nenhum
// campo de imposto no pedido) — melhor omitir do que estimar um número
// sem base.
const FinancialSummaryCard = ({ summary }) => {
  const grossRevenue = summary?.grossRevenue ?? 0;
  const costs = summary?.costs ?? 0;
  const netProfit = summary?.netProfit ?? 0;

  return (
    <div className="financial-summary-card">
      <h5 className="mb-3">Resumo financeiro</h5>
      <div className="financial-summary-card__row">
        <span>Faturamento bruto</span>
        <span>{formatBRL(grossRevenue)}</span>
      </div>
      <div className="financial-summary-card__row">
        <span>Custos</span>
        <span>- {formatBRL(costs)}</span>
      </div>
      <div className="financial-summary-card__row financial-summary-card__row--total">
        <span>Lucro líquido</span>
        <span>{formatBRL(netProfit)}</span>
      </div>
    </div>
  );
};

export default FinancialSummaryCard;
